import React, { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../lib/api";
import { formatApiErrorDetail } from "../context/AuthContext";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await forgotPassword({ email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="min-h-screen flex items-center justify-center relative z-10 px-6 pt-28 pb-16">
      <div className="w-full max-w-md">
        <p className="overline text-[#9A7420] mb-3 text-center">Password Recovery</p>
        <h1 className="font-display text-5xl tracking-tight text-center mb-4">Forgot password</h1>
        <p className="text-center text-[#57515F] mb-10 text-sm">
          Enter the email on your Women Heaven account. We&apos;ll send you a link to set a new password.
        </p>

        {sent ? (
          <div data-testid="fp-sent" className="bg-white border border-[#DAD5E2] rounded-2xl p-8 text-center">
            <MailCheck className="w-10 h-10 text-[#9A7420] mx-auto mb-4" strokeWidth={1.5} />
            <p className="font-display text-2xl mb-2">Check your inbox</p>
            <p className="text-sm text-[#57515F] mb-6">
              If that email is registered, a reset link is on its way. The link expires in 30 minutes.
            </p>
            <Link to="/login" data-testid="fp-back-login" className="text-[#9A7420] underline text-sm">Back to sign in</Link>
          </div>
        ) : (
          <form data-testid="forgot-form" onSubmit={submit} className="space-y-7">
            <div>
              <label className="overline block mb-2">Email</label>
              <input data-testid="fp-email" type="email" required className="input-line"
                value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <button data-testid="fp-submit" type="submit" disabled={loading}
              className="btn-primary w-full justify-center">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send reset link"}
            </button>
            <p className="text-center text-[#57515F] text-sm">
              Remembered it?{" "}
              <Link to="/login" data-testid="fp-to-login" className="text-[#9A7420] underline">Sign in</Link>
            </p>
          </form>
        )}
      </div>
    </main>
  );
}
